import { useState } from "react";
import { CheckCircle2 } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function NewsletterSignup({ variant = "light" }) {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const isDark = variant === "dark";

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    // Quietly capture the email so subscribers are saved for launch.
    // Ignore any errors — the customer just needs to know it worked.
    try {
      await axios.post(`${API}/newsletter/subscribe`, { email });
    } catch (err) {
      // no-op: still show the friendly coming-soon confirmation
    }
    setEmail("");
    setLoading(false);
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div
        className={`rounded-2xl p-5 flex items-start gap-3 ${
          isDark ? "bg-white/10 border border-white/20" : "bg-sage/10 border border-sage/20"
        }`}
        data-testid="newsletter-coming-soon"
      >
        <CheckCircle2 size={20} className={isDark ? "text-white mt-0.5" : "text-olive mt-0.5"} />
        <div>
          <p className={`font-medium text-sm ${isDark ? "text-white" : "text-black"}`}>
            You're on the list!
          </p>
          <p className={`text-sm mt-1 ${isDark ? "text-white/70" : "text-charcoal/60"}`}>
            The newsletter is coming soon — I'll be in touch with news, events and good vibes as soon
            as it launches. Thank you for signing up!
          </p>
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-3" data-testid="newsletter-form">
      <span
        className={`inline-flex items-center gap-1.5 self-start rounded-full px-3 py-1 text-[10px] font-medium uppercase tracking-wider ${
          isDark ? "bg-white/10 text-white/70" : "bg-sage/15 text-olive"
        }`}
        data-testid="newsletter-coming-soon-badge"
      >
        Coming soon
      </span>
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="Your email address"
        className={`rounded-xl px-4 py-3 text-sm outline-none transition-all ${
          isDark
            ? "bg-white/10 border border-white/20 text-white placeholder:text-white/40 focus:border-white/40"
            : "bg-white/50 border border-ocean/10 text-black placeholder:text-charcoal/40 focus:ring-2 focus:ring-sage focus:border-transparent"
        }`}
        data-testid="newsletter-email-input"
      />
      <button
        type="submit"
        disabled={loading}
        className={`rounded-full px-6 py-3 text-sm font-medium transition-all duration-300 ${
          isDark
            ? "bg-white text-black hover:bg-white/90"
            : "bg-olive text-white hover:bg-amber hover:-translate-y-0.5"
        }`}
        data-testid="newsletter-submit-btn"
      >
        {loading ? "Joining..." : "Join the Vibe"}
      </button>
    </form>
  );
}
